import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import Api from '../api/api';
import Loader from '../shared/loader';
import arrayUtilities from '../../utilities/arrayUtilities';

function CancellationReasons(props) {
    const [cancellationReasons, setCancellationReasons] = useState(null);
    const [loadingCancellationReasons, setLoadingCancellationReasons] = useState(false)
    const [voidReasons, setVoidReasons] = useState(null);
    const [loadingVoidReasons, setLoadingVoidReasons] = useState(false)

    const getReasons = function () {
        setLoadingCancellationReasons(true)
        Api.getCancellationReasons(
            (data) => {
                setCancellationReasons(data)
                setLoadingCancellationReasons(false)
            },
            (error) => {
                console.log(error)
                setLoadingCancellationReasons(false)
            },
            props.organisationId,
            props.token
        )
    };

    const getVoidReasons = () => {
        setLoadingVoidReasons(true)
        Api.getVoidReasons(
            (data) => {
                setVoidReasons(data)
                setLoadingVoidReasons(false)
            },
            (error) => {
                console.log(error)
                setLoadingVoidReasons(false)
            },
            props.organisationId,
            props.token
        )
    }

    useEffect(() => {
        getReasons();
        getVoidReasons()
    }, []);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="row align-items-center justify-content-between">
                                <div className="col-auto d-flex align-items-center pr-0">
                                    <h5 className="mb-0">Cancellation Reasons</h5>
                                </div>
                                <div className="col-auto text-right pl-0 filter-buttons-wrapper">
                                    <Link className="btn btn-success btn-sm mr-1 ml-1" to={ `/organisation/${props.organisationId}/cancellation-reason` }><i className="fas fa-plus mr-1"></i>Add</Link>
                                </div>
                            </div>
                        </div>
                        <div className="card-body bg-light border-top p-0">
                            <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer " style={ { tableLayout: 'fixed' } }>
                                <thead className="bg-200 text-900">
                                    <tr>
                                        <th style={ { width: '30%' } }>Name</th>
                                        <th>Description</th>
                                        <th className="text-center" style={ { width: '30%' } }>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { loadingCancellationReasons
                                        ? <tr> <td colSpan={ 3 }><Loader /></td></tr>
                                        : !arrayUtilities.isNullOrEmpty(cancellationReasons) && cancellationReasons.map((reason) => 
                                        <tr>
                                            <td><Link to={ `/organisation/${ props.organisationId }/cancellation-reason/${ reason.id }` }><h6 className="mb-0">{ reason.name }</h6></Link></td>
                                            <td>{ reason.description }</td>
                                            <td className="text-center">{ reason.isActive && <><i className="fas fa-check text-success"></i></> }{ !reason.isActive && <><i className="fas fa-times text-danger"></i></> }</td>
                                        </tr>)
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="row align-items-center justify-content-between">
                                <div className="col-auto d-flex align-items-center pr-0">
                                    <h5 className="mb-0">Void Reasons</h5>
                                </div>
                                <div className="col-auto text-right pl-0 filter-buttons-wrapper">
                                    <Link className="btn btn-success btn-sm mr-1 ml-1" to={ `/organisation/${props.organisationId}/void-reason` }><i className="fas fa-plus mr-1"></i>Add</Link>
                                </div>
                            </div>
                        </div>
                        <div className="card-body bg-light border-top p-0">
                            <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer " style={ { tableLayout: 'fixed' } }>
                                <thead className="bg-200 text-900">
                                    <tr>
                                        <th style={ { width: '30%' } }>Name</th>
                                        <th>Description</th>
                                        <th className="text-center" style={ { width: '30%' } }>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { loadingVoidReasons
                                        ? <tr> <td colSpan={ 3 }><Loader /></td></tr>
                                        : !arrayUtilities.isNullOrEmpty(voidReasons) && voidReasons.map((reason) => 
                                        <tr>
                                            <td><Link to={ `/organisation/${ props.organisationId }/void-reason/${ reason.id }` }><h6 className="mb-0">{ reason.name }</h6></Link></td>
                                            <td>{ reason.description }</td>
                                            <td className="text-center">{ reason.isActive && <><i className="fas fa-check text-success"></i></> }{ !reason.isActive && <><i className="fas fa-times text-danger"></i></> }</td>
                                        </tr>)
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CancellationReasons;